// src/vatandas/pages/KisaLinkPage.js  (FAZ-63)
//
// SMS'teki kısa linkin ("{ana}/g/<kod>") karşılandığı sayfa.
//
// AKIŞ:
//   1) Kodu backend'e sor  → {"path": "/yonetim/gorevler/12"}
//   2) Oturum VARSA        → doğrudan hedefe (replace: geri tuşu buraya dönmesin)
//   3) Oturum YOKSA        → /giris?next=<hedef> → giriş → hedef
//   4) Kod geçersizse      → sade bilgi ekranı (ham hata gösterilmez)
//
// NEDEN AYRI SAYFA: kısa link kodunu doğrudan göreve çevirmek backend'in işi
// (tıklama sayacı + hedefin tek doğru kaynağı orada). SPA yalnız çözüp yönlendirir.

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import api from "../services/vatandasApi";
import { safeNextPath } from "../utils/safeNext";

const LS_ACCESS = "accessToken";

const DURUM = {
  COZULUYOR: "cozuluyor",
  HATA: "hata",
};

const KisaLinkPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [durum, setDurum] = useState(DURUM.COZULUYOR);

  useEffect(() => {
    let iptal = false;

    const coz = async () => {
      if (!code) {
        if (!iptal) setDurum(DURUM.HATA);
        return;
      }

      try {
        const res = await api.get(`/sms-center/kisa-link/${encodeURIComponent(code)}/`);

        // Backend zaten göreli yol döndürmeyi garanti ediyor; yine de süzüyoruz —
        // yönlendirme kararını veren taraf her zaman kendi doğrulamasını yapmalı.
        const hedef = safeNextPath(res?.data?.path);
        if (!hedef) {
          if (!iptal) setDurum(DURUM.HATA);
          return;
        }
        if (iptal) return;

        const girisli = Boolean(localStorage.getItem(LS_ACCESS));
        if (girisli) {
          navigate(hedef, { replace: true });
        } else {
          navigate(`/giris?next=${encodeURIComponent(hedef)}`, { replace: true });
        }
      } catch {
        // 404 (bilinmeyen kod) / 410 (pasif, süresi dolmuş) / ağ hatası —
        // kullanıcıya hepsi aynı görünür, sistem içi ayrıntı sızdırmayız.
        if (!iptal) setDurum(DURUM.HATA);
      }
    };

    coz();
    return () => {
      iptal = true;
    };
  }, [code, navigate]);

  if (durum === DURUM.HATA) {
    return (
      <div style={styles.sarmal}>
        <div style={styles.kart}>
          <ExclamationTriangleIcon style={styles.ikon} aria-hidden="true" />
          <h1 style={styles.baslik}>Bağlantı geçersiz</h1>
          <p style={styles.metin}>
            Bu bağlantı geçersiz veya süresi dolmuş olabilir. Panele giriş yapıp
            ilgili kaydı listeden açabilirsiniz.
          </p>
          <button
            type="button"
            style={styles.dugme}
            onClick={() => navigate("/giris", { replace: true })}
          >
            Giriş sayfasına git
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.sarmal} role="status" aria-live="polite">
      <div style={styles.kart}>
        <div style={styles.spinner} aria-hidden="true" />
        <p style={styles.metin}>Bağlantı açılıyor...</p>
      </div>
    </div>
  );
};

const styles = {
  sarmal: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  kart: {
    maxWidth: 420,
    width: "100%",
    textAlign: "center",
    padding: "32px 24px",
    borderRadius: 16,
    background: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,.08)",
  },
  ikon: { width: 44, height: 44, color: "#d97706", margin: "0 auto 12px" },
  baslik: { fontSize: 20, fontWeight: 600, margin: "0 0 8px" },
  metin: { fontSize: 15, color: "#4b5563", margin: "0 0 20px", lineHeight: 1.5 },
  dugme: {
    padding: "10px 20px",
    borderRadius: 10,
    border: "none",
    background: "#1d4ed8",
    color: "#fff",
    fontSize: 15,
    cursor: "pointer",
  },
  spinner: {
    width: 36,
    height: 36,
    margin: "0 auto 16px",
    borderRadius: "50%",
    border: "3px solid #e5e7eb",
    borderTopColor: "#1d4ed8",
    animation: "spin 0.8s linear infinite",
  },
};

export default KisaLinkPage;
